import React from 'react'

export default function GainAccess({
  account, flashMessageRef, gainAccessPath, getTenantRequestAccessInfoPath, latestTenantAccessRequest, setLatestTenantAccessRequest, setLoading
}) {
  const gainAccess = _e => {
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: gainAccessPath,
      dataType: 'json',
      success: res => {
        setLoading(false)
        setLatestTenantAccessRequest(res.latestTenantAccessRequest)
      },
      error: res => {
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }
  
  const handleClick = _e => {
    setLoading(true)

    Rails.ajax({
      type: 'GET',
      url: getTenantRequestAccessInfoPath,
      dataType: 'json',
      success: res => {
        setLoading(false)

        window.open(`${ account.domain }/admin?dir_access_info=${ encodeURIComponent(res.accessInfo) }`, '_blank')
      },
      error: res => {
        setLoading(false)

        flashMessageRef.current.show(res.message, 'error')
        setLatestTenantAccessRequest(null)
      }
    })
  }

  return (
    <>
      { (!latestTenantAccessRequest || latestTenantAccessRequest.access_type === 'gain_access') &&
        <>
          { latestTenantAccessRequest && latestTenantAccessRequest.active && latestTenantAccessRequest.access_granted
            ? <div className="access-requested flex-box items-center">
                <div 
                  className="btn m-b-5 flex-box items-center content-center"
                  style={{ cursor: 'pointer' }}
                  onClick={ handleClick }
                >
                  <span>{ `${ account.name } admin` }</span>
                  <i className='fa-light fa-arrow-up-right-from-square' />
                </div>

                <div className="m-l-20">
                  { `Access Expires In ${ latestTenantAccessRequest.remaining_minutes } minutes` }
                </div>
              </div>
            : <div 
                className="btn flex-box items-center content-center"
                style={{ cursor: 'pointer' }}
                onClick={ gainAccess }
              >
                <i className='fa-light fa-shield-halved m-r-10' />
                <span>
                  Gain Access
                </span>
              </div>
          }
        </>
      }
    </>
  )
}